import { useQuery } from "@apollo/react-hooks";
import { SPVCompaniesWithTokenizedInvestment } from "./graphql/SPVCompaniesWithTokenizedInvestment";
import { SPV_COMPANIES_WITH_TOKENIZED_INVESTMENT } from "./Queries";

export const GetSPVCompaniesWithTokenizedInvestment = () =>
  useQuery<SPVCompaniesWithTokenizedInvestment>(SPV_COMPANIES_WITH_TOKENIZED_INVESTMENT);
